import React, { useEffect, useState } from "react";
import "../company/formstyle.css";
import './JobStreamChangeForm.css';
import { useNavigate } from "react-router-dom";
import EmployeeNavbar from "../Employees/EmployeeNavbar";
import axios from "axios";
import url from "../../function/url";
import Cookies from "js-cookie";
import Swal from "sweetalert2";

const JobStreamChangeForm = () => {
  const [employeeName, setEmployeeName] = useState("");
  const [cnumber, setCnumber] = useState("");
  const [email, setEmail] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [currentJobOrStream, setCurrentJobOrStream] = useState("");
  const [requestedChange, setRequestedChange] = useState("");
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });

  useEffect(() => {
    const logId = Cookies.get("log_id");
    
        if (!logId) {
          setErrors("User not logged in or session expired. Please log in again.");
          setLoading(false);
          return;
        }
    
        console.log("Log Id :", logId);

    // Fetch employee details using log_id
    axios
      .get(`${url.path}/get-employee-details/?log_id=${logId}`)
      .then((response) => {
        const data = response.data;
        setEmployeeName(data.Employee_Name || "");
        setCnumber(data.Contact_number || "");
        setEmail(data.Email || "");
        setEmployeeId(data.Employee_ID || "");
       
      })
      .catch((error) => {
        console.error("Error fetching employee details:", error);
        
        Toast.fire({
          icon: "error",
          title: "Failed to fetch employee details.",
        });
      });
  }, [navigate]);


  const validateForm = () => {
    const newErrors = {};

    // Employee name validation
    if (!employeeName.trim()) {
      newErrors.employeeName = "Employee name is required.";
    }

    // Contact number validation
    const phoneRegex = /^\d{10}$/;
    if (!cnumber.trim()) {
      newErrors.cnumber = "Contact number is required.";
    } else if (!phoneRegex.test(cnumber)) {
      newErrors.cnumber = "Contact number must be a 10-digit number.";
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!emailRegex.test(email)) {
      newErrors.email = "Please enter a valid email address.";
    }

    // Employee ID validation
    if (!employeeId.trim()) {
      newErrors.employeeId = "Employee ID is required.";
    }

    // Current job/stream validation
    if (!currentJobOrStream.trim()) {
      newErrors.currentJobOrStream = "Current job/stream is required.";
    }

    // Requested change validation
    if (!requestedChange) {
      newErrors.requestedChange = "Please select a change type.";
    }

    // Reason validation
    if (!reason.trim()) {
      newErrors.reason = "Reason for change is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      const formdata = new FormData();
      formdata.append("employee_name", employeeName);
      formdata.append("contact_number", cnumber);
      formdata.append("email", email);
      formdata.append("employee_id", employeeId);
      formdata.append("current_job_or_stream", currentJobOrStream);
      formdata.append("requested_change", requestedChange);
      formdata.append("reason", reason);

      axios
        .post(`${url.path}/change-request/`, formdata)
        .then((res) => {
          if (res.status === 201) {
            Toast.fire({
              icon: "success",
              title: "Request submitted successfully!",
            });
            navigate("/employee_home_page"); // Change this path to your desired route.
          } else {
            
            Toast.fire({
              icon: "error",
              title: "Something went wrong. Please try again.",
            });
          }
        })
        .catch((error) => {
          console.error("Error submitting the form:", error);
          Toast.fire({
            icon: "error",
            title: "Failed to submit the request.",
          });
        });
    }
  };

  return (
    <>
      <EmployeeNavbar />
      <div className="page-wrapper">
        <div className="form-container">
          <h1 style={{ fontSize: "30px" }}>Request Job/Stream Change</h1>
          <form onSubmit={handleSubmit}>
            <label>
              Employee Name:
              <input
                type="text"
                value={employeeName}
                onChange={(e) => setEmployeeName(e.target.value)}
                readOnly
              />
              {errors.employeeName && <span className="error" style={{color:'red'}}>{errors.employeeName}</span>}
            </label>

            <label>
              Contact Number:
              <input
                type="text"
                value={cnumber}
                onChange={(e) => setCnumber(e.target.value)}
                readOnly
              />
              {errors.cnumber && <span className="error" style={{color:'red'}}>{errors.cnumber}</span>}
            </label>

            <label>
              Email ID:
              <input
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                readOnly
              />
              {errors.email && <span className="error"  style={{color:'red'}}>{errors.email}</span>}
            </label>

            <label>
              Employee ID:
              <input
                type="text"
                value={employeeId}
                onChange={(e) => setEmployeeId(e.target.value)}
                readOnly
              />
              {errors.employeeId && <span className="error" style={{color:'red'}}>{errors.employeeId}</span>}
            </label>

            <label>
              Current Job/Stream:
              <input
                type="text"
                value={currentJobOrStream}
                onChange={(e) => setCurrentJobOrStream(e.target.value)}
              />
              {errors.currentJobOrStream && (
                <span className="error" style={{color:'red'}}>{errors.currentJobOrStream}</span>
              )}
            </label>

            <label>
              Requested Change:
              <select
                value={requestedChange}
                onChange={(e) => setRequestedChange(e.target.value)}
              >
                <option value="">Select</option>
                <option value="job">Job</option>
                <option value="stream">Stream</option>
              </select>
              {errors.requestedChange && (
                <span className="error" style={{color:'red'}}>{errors.requestedChange}</span>
              )}
            </label>

            <label>
              Reason for Change:
              <textarea
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              ></textarea>
              {errors.reason && <span className="error" style={{color:'red'}}>{errors.reason}</span>}
            </label>

            <center>
              <button
                style={{
                  width: "150px",
                  height: "40px",
                  borderRadius: "10px",
                  color: "black",
                  backgroundColor: "gainsboro",
                }}
                type="submit"
              >
                Submit Request
              </button>
            </center>
          </form>
        </div>
      </div>
    </>
  );
};

export default JobStreamChangeForm;
